
import styled from 'styled-components';

import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { StepWrapper } from 'pages/checkout-v3/components/common/layout-styled-components';
import { BaseBodyText, BaseHeaderText } from 'pages/checkout-v3/components/common/typographic-styled-components';

// For shared styles between InsuranceInfo and PatientInfo

export const InsuranceStepWrapper = styled(StepWrapper).attrs({ as: 'form' })`
  align-items: stretch;
`;

export const FormRow = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(0, 1fr);
  column-gap: 16px;
`;

export const SectionHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
`;

export const SectionHeader = styled(BaseHeaderText)`
  ${TYPOGRAPHY.CIRCULAR.black}
  font-size: 18px;
  line-height: 26px;
`;

export const SectionSubheader = styled(BaseBodyText)``;
